
















import { PropType } from 'vue';
import CoIcon from '@/components/Atoms/co-icon/CoIcon.vue';
import CoMultiSelect from '../co-multiselect/CoMultiSelect.vue';

interface Column {
    title: string;
    key: string;
    hidden?: boolean;
    disabled: boolean;
    alwaysSelected: boolean;
}

interface MultiSelectItem {
    Name: string;
    Value: string;
    Disabled: boolean;
    AlwaysSelected: boolean;
}

export default {
    name: 'CoTableColumnSelector',
    components: {
        CoMultiSelect,
        CoIcon,
    },
    props: {
        columns: {
            type: Array as PropType<Column[]>,
            default() {
                return [];
            },
        },
        value: {
            type: Array as PropType<string[] | null>,
            default: null,
        },
        defaultSelectedColumns: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            selectedColumnKeys: [] as string[],
        };
    },
    computed: {
        availableColumns(): Column[] {
            return (this.columns || []).filter((column) => !column.hidden);
        },
        columnItems(): MultiSelectItem[] {
            return this.availableColumns.map((column) => ({
                Name: column.title,
                Value: column.key,
                Disabled: column.disabled,
                AlwaysSelected: column.alwaysSelected,
            }));
        },
        selectedItems(): MultiSelectItem[] {
            return this.columnItems.filter((item) => this.selectedColumnKeys.includes(item.Value));
        },
    },
    watch: {
        columns: {
            handler() {
                this.syncSelectedColumns();
            },
            immediate: true,
            deep: true,
        },
        value: {
            handler() {
                this.syncSelectedColumns();
            },
            immediate: true,
        },
        defaultSelectedColumns() {
            this.syncSelectedColumns();
        },
    },
    methods: {
        getDefaultSelectedColumnKeys(): string[] {
            const availableKeys = this.availableColumns.map((column) => column.key);
            if (Array.isArray(this.value)) {
                const controlledKeys = this.value.filter((key) => availableKeys.includes(key));
                return controlledKeys;
            }

            const defaultKeys = (this.defaultSelectedColumns || []).filter((key) => availableKeys.includes(key));
            return defaultKeys.length > 0 ? defaultKeys : availableKeys;
        },
        syncSelectedColumns() {
            // Keep the local selection aligned with the available columns and optional defaults.
            this.selectedColumnKeys = this.getDefaultSelectedColumnKeys();
        },
        updateSelection(selectedItems: MultiSelectItem[]) {
            this.selectedColumnKeys = (selectedItems || []).map((item) => item.Value);
            const selectedColumns = this.availableColumns.filter((column) =>
                this.selectedColumnKeys.includes(column.key)
            );

            this.$emit('input', this.selectedColumnKeys);
            this.$emit('select', selectedColumns);
        },
    },
};
